// Raw, un-normalized place payload seeded once by SSR so the place page can hydrate
// without an extra client fetch. Never dispatched to after that.
export function ssrPlace(state = null) {
  return state;
}
